import { render, staticRenderFns } from "./SupplierOrdersDetail.vue?vue&type=template&id=8cb196ec&"
import script from "./SupplierOrdersDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierOrdersDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrdersDetail.vue?vue&type=style&index=0&id=8cb196ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports